/**
 * Admin Twilio Migration API
 */

import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  MigrateTwilioWebhookBodySchema,
  MigrateTwilioWebhookResponseSchema,
  MigrateVoiceWebhookBodySchema,
  MigrateVoiceWebhookResponseSchema,
  TransferPhoneBodySchema,
  TransferPhoneResponseSchema,
  TwilioMigrationRecordSchema,
  TwilioMigrationStatusResponseSchema,
  VoiceMigrationRecordSchema,
  VoiceMigrationStatusResponseSchema
} from "./schemas/twilio-migration.schemas";

export const ZAdminTwilioMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/twilio/status",
    Params: z.object({ checkTwilio: z.string().optional() }),
    Response: ApiSuccessSchema(TwilioMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/twilio/migrate",
    Body: MigrateTwilioWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateTwilioWebhookResponseSchema)
  },
  Transfer: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/twilio/transfer",
    Body: TransferPhoneBodySchema,
    Response: ApiSuccessSchema(TransferPhoneResponseSchema)
  },
  GetVoiceStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/twilio/status/voice",
    Params: z.object({ checkTwilio: z.string().optional() }),
    Response: ApiSuccessSchema(VoiceMigrationStatusResponseSchema)
  },
  MigrateVoice: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/twilio/migrate/voice",
    Body: MigrateVoiceWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateVoiceWebhookResponseSchema)
  }
} as const;

export type TApiAdminTwilioMigration = InferSchemas<typeof ZAdminTwilioMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================

export type TwilioMigrationRecord = z.infer<typeof TwilioMigrationRecordSchema>;
export type TwilioMigrationStatusResponse = z.infer<typeof TwilioMigrationStatusResponseSchema>;
export type VoiceMigrationRecord = z.infer<typeof VoiceMigrationRecordSchema>;
export type VoiceMigrationStatusResponse = z.infer<typeof VoiceMigrationStatusResponseSchema>;
